import {
  Datagrid,
  DateField,
  ImageField,
  ReferenceArrayField,
  ReferenceField,
  ShowButton,
  TextField,
  useRecordContext,
} from 'react-admin';

export const AppTrialsField = (
  props: any = {
    label: 'Apps',
    source: 'trial_app_ids',
    reference: 'app_trials',
  },
) => {
  const record = useRecordContext();

  return (
    <ReferenceArrayField
      source={props.source}
      reference={props.reference}
      label={props.label}
      emptyText="-"
      record={record}
    >
      <Datagrid size="medium" bulkActionButtons={false} empty={<>-</>}>
        <ImageField
          label={false}
          source="icon.src"
          sx={{
            '& img': { width: '40px !important', height: '40px !important' },
          }}
          emptyText=""
        />

        <TextField source="translated_name" />
        <DateField source="valid_from" />
        <DateField source="valid_until" />
        <DateField source="created_at" />
        <ReferenceField reference="apps" source="app_id" link="show">
          <ShowButton />
        </ReferenceField>
      </Datagrid>
    </ReferenceArrayField>
  );
};
